import { cn } from "@/lib/utils";
import { Check, X } from "lucide-react";
import { useRecordContext } from "ra-core";

export const BooleanField = ({ source, looseValue = false, className }: { source: string, looseValue?: boolean, className?: string }) => {
    const record = useRecordContext();
    if (!record) return null;

    let value = record[source];
    if (looseValue) {
        value = !!value;
    }

    return (
        <span className={cn("inline-flex items-center justify-center w-6 h-6 rounded-full", value ? "bg-emerald-100 text-emerald-600" : "text-slate-400", className)}>
            {value ? <Check className="w-4 h-4" /> : <X className="w-4 h-4 opacity-50" />}
        </span>
    );
};
